/*
 *   File : rebalance-status.js
 *   Author : https://evoqins.com
 *   Description : Rebalance status modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Assets
import Success from "../../Assets/Images/Modal/rebalance-success.webp";

//Custom components
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';

const RebalanceStatusModal = (props) => {

    const navigate = useNavigate();
    const [statusImg, setStatusImg] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");


    useEffect(() => {

        // if (props.type === 1) {
        //     setStatusImg(Success);
        //     setTitle("Stocks Redeemed Successfully");
        //     setDescription("The selected stocks have been successfully redeemed. The proceeds from this redemption will be allocated to your chosen assets to optimize your portfolio.");
        // } else if (props.type === 2) {
        //     setStatusImg(Success);
        //     setTitle("Rebalancing Complete");
        //     setDescription("You have successfully rebalanced your portfolio. Your investments are now aligned with your target allocation, optimizing growth and managing risk.");
        // }

        if (props.type === 1) {
            setStatusImg(Success);
            setTitle("Rebalancing Complete");
            setDescription("You have successfully rebalanced your portfolio. Your investments are now aligned with your target allocation, optimizing growth and managing risk.");
        } else {
            setStatusImg(Success);
            setTitle("Rebalancing");
            setDescription(props.statusMessage);
        }

    }, [props.type]);

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("rebalance-status-modal-close");
        button.click();
        props.handleClose();
    };

    // handle close modal
    const _handleSuccess = () => {
        var button = document.getElementById("rebalance-status-modal-close");
        button.click();
        if (props.type === 2) {
            navigate("/portfolio");
        } else {
            props.handleSuccess();
        }
    };


    return (
        <div className="modal fade"
            id="rebalance-status-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="rebalance-status-modal"
            aria-hidden="true">

            <div className={`modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5`}>
                <span id='rebalance-status-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 overflow-hidden border-0 mx-lg-5">
                    {/* modal header */}
                    {/* <div className="modal-header border-0 justify-content-end align-items-center pt-3 px-3 pb-0">
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer"
                            onPress={_handleCloseModal} />
                    </div> */}
                    {/* Modal body */}
                    <div className='modal-body py-0 px-3 px-sm-4 text-center'>
                        <img src={statusImg}
                            draggable={false}
                            width={240}
                            alt='subscription' />

                        <h4 className='padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px'>
                            {title}
                        </h4>
                        <p className='px-5 mb-0 e-alt-font-lato e-font-14 e-text-outer-space e-font-weight-400 line-height-20px'>
                            {description}
                        </p>
                        <div className="margin-20px-tb">
                            <PrimaryButton name={props.type == 1 ? "View Details" : "View Portfolio"}
                                padding="padding-18px-tb e-padding-8px-tb-res"
                                className="e-letter-spacing-min-point-1px e-font-16 e-font-14-res w-100"
                                onPress={_handleSuccess} />
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default memo(RebalanceStatusModal);
